// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }



// 专题页面配置接口
export function specialSubjectConfig(params) {
  return request({
    url: "/api/article/special_subject_config",
    method: "get",
    params,
  });
}

